import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

const application = Application.start()
// changed includeSubdirs to false to manually include folders in specific pack
const context = require.context("controllers/application_dashboard", false, /_controller\.js$/)
application.load(definitionsFromContext(context))
